module.exports = __webpack_public_path__ + "img/icon-ranking-5@3x.431e5e77.png";